import primary from './primary/client';
import admin from './admin/client';

export default {
  install(Vue, options) {
    const clients = {
      ...options,
      primary,
      admin,
    };
    // eslint-disable-next-line
    Vue.$apollo = clients;

    Object.defineProperties(Vue.prototype, {
      $apollo: {
        get() {
          return clients;
        },
      },
    });
  },
};
